export default __webpack_public_path__ + "static/media/payment-icon.7a889663.svg";